<template>
  <div class="d-block d-md-none">{{ column }}</div>
  <div v-if="list && list.length">
    <template v-for="(item, index) in list" :key="item.id">
      <div v-if="index < 1">
        <TextCellDataTableComponent :item="item" :actions="actions" @emitRowAction="emitRowAction" />
      </div>
    </template>
    <button v-if="list.length > 1" class="other__link" @click="handleModalOpen(true)">{{ otherItemNumber }}</button>
  </div>
  <div v-else class="dataTable__empty">{{ $t("global.empty.no_data_available") }}</div>
  <TextContentModalComponentModalComponent
    :opened="modalOpen"
    :list="list"
    :actions="actions"
    @hidden="handleModalOpen(false)"
    @emitRowAction="emitRowAction"
  />
</template>

<script>
import TextCellDataTableComponent from "@/components/data-table/cell/TextCellDataTableComponent.vue";
import TextContentModalComponentModalComponent from "@/components/data-table/modal/TextContentModalComponent.vue";

export default {
  name: "ListTextCellDataTableComponent",
  components: {
    TextContentModalComponentModalComponent,
    TextCellDataTableComponent,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    column: {
      type: String,
      required: true,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      modalOpen: false,
    };
  },
  computed: {
    otherItemNumber() {
      const itemNumber = this.list.length - 1;
      const text = this.$tc("global.other", itemNumber > 1 ? 2 : 1).toLowerCase();
      return "+" + itemNumber + " " + text;
    },
  },
  methods: {
    handleModalOpen(value) {
      this.modalOpen = value;
    },
    emitRowAction(payload) {
      this.$emit("emitRowAction", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.other__link {
  margin-top: 5px;
  font-size: 12px;
  background-color: inherit;
  border: none;
  color: $info;
}
</style>
